import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import http from './http'
import { CreateTaskData } from '../types/task'
import { ScheduleTasks } from '../types/schedule'

export function updateTask(
	taskId: string,
	data: object
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'PUT',
		url: `/p/task/${taskId}`,
		data,
	})
}

export function deleteTask(taskId: string): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'DELETE',
		url: `/p/task/${taskId}`,
	})
}

export function create(data: CreateTaskData): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: '/p/task',
		data,
	})
}

export function getTasks(): AxiosPromise<AppApiResponseData<ScheduleTasks>> {
	return http({
		method: 'GET',
		url: '/p/task',
	})
}
